import React, { useEffect, useState } from 'react';
import Icon from '../icon/icon';
import useTranslate from '../../../common/hooks/useTranslate';
import { getUserSettings, saveUserSettings } from '../../../common/services/http/userService';

import './infoTooltip.scss';

const InfoTooltip = () => {
  const { t } = useTranslate();
  const [tooltipHidden, setTooltipHidden] = useState(true);

  const closeInfoTooltip = (): void => {
    setTooltipHidden(true);
    sessionStorage.setItem('docuSlicerTooltipHidden', '1');
  };

  const doNotShowAgain = () => {
    setTooltipHidden(true);
    const slicerTooltipSetting = { name: 'docuSlicerTooltipHidden', value: '1' };
    saveUserSettings(slicerTooltipSetting);
  };

  useEffect(() => {
    const stored = sessionStorage.getItem('docuSlicerTooltipHidden');
    if (stored === null) {
      getUserSettings().then((settings) => {
        const settingHideTooltip = settings.find((setting) => {
          return setting.name === 'docuSlicerTooltipHidden';
        });
        if (settingHideTooltip === undefined) {
          setTooltipHidden(false);
        } else if (settingHideTooltip.value === '1') {
          setTooltipHidden(true);
        } else {
          setTooltipHidden(false);
        }
      });
    } else {
      setTooltipHidden(true);
    }
  }, []);

  return (
    <div>
      {!tooltipHidden && (
        <div className="filters-slicer-tooltip">
          <div className="bottom-arrow"></div>
          <div className="tooltip-content">
            <p>{t('FILTERS.TOOLTIP_TEXT')}</p>
            <button className="tooltip-button pointer" onClick={doNotShowAgain}>
              {t('FILTERS.TOOLTIP_BUTTON')}
            </button>
          </div>
          <div className="tooltip-right">
            <Icon name="fas fa-times-circle" className="close-circle-btn pointer" onClick={closeInfoTooltip} />
          </div>
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;
